export const settingKeysConstant = {
    "AUTO_PLAY": "AUTO_PLAY",
    "AUTO_NEXT_LESSON": "AUTO_NEXT_LESSON",
    "THEME": "THEME"
};